module.exports = __webpack_public_path__ + "static/photogrammetry_detail-c25e15815039261679e61bce09186b2e.jpg";